import { getProjectJobsStatusApi } from "../../Services/JobsService";
import { RestApiResponse } from "../../Models/RestApiResponse";
import { notAuthorised } from "../../StateStore/UserAuth/UserAuthActions";
import { DBJob } from "../../Models/ProjectJobsStatus";
import { DBJobStatus } from "../../Models/ProjectJobsStatus";
import { JobsStatus } from "../../Models/ProjectJobsStatus";
import { getProjectJobsStatusLoadingAction, getProjectJobsStatusAction, getProjectJobsStatusErrorAction } from "../../StateStore/ProjectJobsStatusModal/ProjectJobsStatusModalActions";

const convertToDBJob = (data: any): DBJob => {
  return {
    id: data.id,
    creationdate: {
      value: {
        seconds: data.creationdate.value.seconds,
        nanos: 0
      }
    },
    name: data.name,
    state: data.state ? data.state : 0,
    jobType: data.jobType ? data.jobType : 0,
    customUrl: data.customUrl ? { value: data.customUrl.value } : null,
    cronExpression: data.cronExpression ? { value: data.cronExpression.value } : null,

    lastSuccessfulRun: data.lastSuccessfulRun ? {
      value: {
        seconds: data.lastSuccessfulRun.value.seconds,
        nanos: 0
      }
    } : null,

    lastImportedTimestamp: data.lastImportedTimestamp ? {
      value: {
        seconds: data.lastImportedTimestamp.value.seconds,
        nanos: 0
      }
    } : null,

    maxImportTimespanInDays: data.maxImportTimespanInDays,
    tenant_id: data.tenant_id ? { value: data.tenant_id.value } : null,
    agroups: data.agroups ? { value: data.agroups.value } : null,
    progress_uuid: data.progress_uuid ? { value: data.progress_uuid.value } : null,
  } 
}

const convertToDBJobStatus = (data: any): DBJobStatus => {
  return {
    id: data.id,
    creationdate: {
      value: {
        seconds: data.creationdate.value.seconds,
        nanos: data.creationdate.value.nanos
      }
    },
    jobid: data.jobid,
    startdate: {
      value: {
        seconds: data.startdate.value.seconds,
        nanos: data.startdate.value.nanos
      }
    },
    enddate: {
      value: {
        seconds: data.enddate.value.seconds,
        nanos: data.enddate.value.nanos
      }
    },
    duration: {
      value: data.duration ? data.duration.value : null
    },
    status: data.status,
    comment: data.comment ? { value: data.comment.value } : null
  };
}

const convertToJobStatus = (data: any): JobsStatus => {
    return {
        jobs: (data.jobs ?? []).map(convertToDBJob),
        jobshistory: (data.jobshistory ?? []).map(convertToDBJobStatus),
    }
};

export const getProjectJobsStatus = (projectId?: number) => (dispatch: any) => {
    dispatch(getProjectJobsStatusLoadingAction(projectId));
    getProjectJobsStatusApi(projectId).then((response: RestApiResponse) => {
        if (response.statusCode === 401) {
            dispatch(notAuthorised());
        }
        if (response.success) {
          if (response.data != null) {
            const jobsStatus = convertToJobStatus(response.data);
            dispatch(getProjectJobsStatusAction(projectId, jobsStatus));
          } else {
            dispatch(getProjectJobsStatusAction(projectId, null));
          } 
        } else {
            const errorCode = response.errorCode ? response.errorCode : "GetDealerProjectsError";
            dispatch(getProjectJobsStatusErrorAction(errorCode));
        }
    });
};